var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (app, hasSnippets, idp) {var index = 1;
if (hasSnippets)
{
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ESetup your application's code\u003C\u002Fh3\u003E";
if (app.snippets.dependencies)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.dependencies) ? "" : pug_interp);
}
if (app.snippets.use)
{
pug_html = pug_html + ("\u003Cp\u003EAdd the following lines to your base code\u003C\u002Fp\u003E" + (null == (pug_interp = app.snippets.use) ? "" : pug_interp));
}
if (!app.snippets.dependencies && !app.snippets.use && app.snippets.setup)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.setup) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECreate an " + (pug.escape(null == (pug_interp = app.thirdParty ? "API" : "Application") ? "" : pug_interp)) + " in&nbsp;\u003Ca href=\"https:\u002F\u002Fapp.auth0.com\" target=\"_blank\"\u003EAuth0 dashboard&nbsp;\u003C\u002Fa\u003E\u003C\u002Fh3\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Fauth0-catalog\u002Fapplication-create.png\" alt=\"Create an Application in Auth0 dashboard\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECreate&nbsp;";
if('database' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fdatabase\" target=\"_blank\"\u003Ea Database&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Database section";
}
if('social' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fsocial\" target=\"_blank\"\u003Ea Social&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Social section";
}
if('enterprise' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fenterprise\" target=\"_blank\"\u003Ean Enterprise&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Enterprise section";
}
if('passwordless' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fenterprise\" target=\"_blank\"\u003Ean Passwordless&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Passwordless section";
}
pug_html = pug_html + "\u003C\u002Fh3\u003E";
var connection_alt = 'Database';
if ('enterprise' === idp.type) connection_alt = 'Enterprise';
if ('social' === idp.type) connection_alt = 'Social'
if ('passwordless' === idp.type) connection_alt = 'Passwordless'
{
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", "https://cdn2.auth0.com/docs/media/auth0-catalog/connection-" + idp.type + ".png", true, true)+pug.attr("alt", "Create a " + connection_alt + " Connection for authentication", true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined,"hasSnippets" in locals_for_with?locals_for_with.hasSnippets:typeof hasSnippets!=="undefined"?hasSnippets:undefined,"idp" in locals_for_with?locals_for_with.idp:typeof idp!=="undefined"?idp:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/auth-catalog/landing-types/platform-connection.pug
// module id = 905
// module chunks = 0